<template lang="html">
  <div class="demographics-editor">
    <template v-for="group in groups">
      <demographic-segment-row
        v-for="(statistic, index) in group.rows"
        :key="statistic.id || index"
        v-model="group.rows[index]"
        :metric-type="group.metricType"
        :category-label="group.label"
        :placeholder="group.placeholder"
        :suggestions="group.suggestions"
        @input="onRowChanged"
        @change="onRowChanged"
        @remove="removeRow(group, $event)"
      />
    </template>

    <a
      v-for="group in groups"
      :key="'add-' + group.metricType"
      href="#"
      class="ui demographics-add-link"
      @click.stop.prevent="addRow(group)"
    >
      <i class="icon add fitted" />
      Add {{ group.label }}
    </a>
  </div>
</template>

<script>
import DemographicSegmentRow from "views/deliverables/components/demographicSegmentRow.vue";
import { DEMOGRAPHIC_GROUPS } from "utils/demographics";

export default {
  components: {
    DemographicSegmentRow,
  },
  props: {
    deliverableId: {
      type: [Number, String],
      required: true,
    },
    initialStatistics: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      groups: DEMOGRAPHIC_GROUPS.map((group) => ({
        ...group,
        rows: this.initialStatistics.filter(
          (statistic) => statistic.metric_type === group.metricType
        ),
      })),
    };
  },
  methods: {
    onRowChanged() {
      this.$emit("change");
    },
    addRow(group) {
      group.rows.push({
        deliverable_id: this.deliverableId,
        metric_type: group.metricType,
        label: "",
        value: "",
      });
    },
    removeRow(group, statistic) {
      group.rows = group.rows.filter(
        (row) => row !== statistic && row.id !== statistic.id
      );
      this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
.demographics-editor {
  display: flex;
  flex-direction: column;
}

.demographics-add-link {
  margin-top: 0.4rem;

  .icon {
    margin-right: 0.2rem;
  }
}
</style>
